import { IconDeviceGamepad2, IconUserBolt, IconUserCog, IconUsers } from '@tabler/icons-react';
import FlagEn from '../assets/images/flag/icon-flag-en.svg';
import FlagRu from '../assets/images/flag/icon-flag-ru.svg';

export const TEST_MODE =
  window.location.hostname === 'localhost' ||
  window.location.hostname.startsWith('192.168.') ||
  window.location.hostname.startsWith('10.');

export const ENUM_CUS_EVENT = {
  inputError: 'inputError',
  translationToast: 'translationToast',
  getGroupData: 'get.group.data',
  getBonusList: 'get.bonus.list',
  getJackpotsList: 'get.jackpots.list',
  getRefcodeList: 'get.refcode.list',
  getPromoList: 'get.bonus.promocode.list',
  logout: 'auth.logout',
  getFreespinList: 'get.freespin.list',
  getBannerSliderList: 'get.banner.slider.list',
  getCasinos: 'get.casinos',
  handlerOnFindClick: 'site.users.onFindClick',
  handlerOnSaveGameGP: 'site.gameProvider.updateCategories',
  openCustomizer: 'site.open.customizer'
};

export const ENUM_TOAST_TYPE = {
  success: 'success',
  error: 'error',
  info: 'info'
};

export const ENUM_LOCALSTORAGE = {
  userId: 'userId',
  superUser: 'superUser',
  login: 'login',
  lang: 'lang',
  themeMode: 'themeMode',
  activeTheme: 'activeTheme',
  groupHash: 'groupHash',
  isLayout: 'isLayout',
  toggleHorizontal: 'toggleHorizontal',
  isCollapse: 'isCollapse',
  borderRadius: 'borderRadius',
  isCardShadow: 'isCardShadow',
  type: 'type',
  showPas: 'showPas',
  pinUserMenu: 'pinUserMenu',
  pinCasinoParam: 'pinCasinoParam',
  showDopInfoUserMenu: 'showDopInfoUserMenu',
  bannerLanguagesHash: 'bannerLanguagesHash',
  schedulerTgId: 'schedulerTgId',
  schedulerBotId: 'schedulerBotId'
};

export const ENUM_CLIENT_TYPE = {
  agent: 'agent',
  manager: 'manager',
  player: 'player'
};

export const ENUM_GROUP_ACTION = {
  add: 'Add new group',
  move: 'Move group',
  rename: 'Rename group',
  info: 'Information',
  edit: 'Edit Group'
};

export const ENUM_BONUS_LABEL = {
  welcome: 'welcome',
  cashback: 'cashback',
  freespin: 'freespin',
  startBot: 'startBot',
  promocode: 'promocode',
  botPhone: 'botPhone',
  jackpot: 'jackpot'
};

export const ENUM_ELEMENT_NAME = {
  groupsTitle: 'home.groups.title',
  groupActionType: 'groups.action.type'
};

export const ENUM_FIELD_TYPE_GROUP = {
  add: 'add',
  edit: 'edit'
};

export const lavishLevelByTitle = {
  low: 'Low (~85% RTP)',
  norm: 'Norm (~90% RTP)',
  high: 'High (~92% RTP)',
  mega: 'Mega (> 100% RTP)'
};

// CONST
export const timezones = [
  { value: '-720', label: 'UTC-12:00' },
  { value: '-690', label: 'UTC-11:30' },
  { value: '-660', label: 'UTC-11:00' },
  { value: '-630', label: 'UTC-10:30' },
  { value: '-600', label: 'UTC-10:00' },
  { value: '-570', label: 'UTC-09:30' },
  { value: '-540', label: 'UTC-09:00' },
  { value: '-510', label: 'UTC-08:30' },
  { value: '-480', label: 'UTC-08:00' },
  { value: '-450', label: 'UTC-07:30' },
  { value: '-420', label: 'UTC-07:00' },
  { value: '-390', label: 'UTC-06:30' },
  { value: '-360', label: 'UTC-06:00' },
  { value: '-330', label: 'UTC-05:30' },
  { value: '-300', label: 'UTC-05:00' },
  { value: '-270', label: 'UTC-04:30' },
  { value: '-240', label: 'UTC-04:00' },
  { value: '-210', label: 'UTC-03:30' },
  { value: '-180', label: 'UTC-03:00' },
  { value: '-150', label: 'UTC-02:30' },
  { value: '-120', label: 'UTC-02:00' },
  { value: '-90', label: 'UTC-01:30' },
  { value: '-60', label: 'UTC-01:00' },
  { value: '-30', label: 'UTC-00:30' },
  { value: '0', label: 'UTC+00:00' },
  { value: '30', label: 'UTC+00:30' },
  { value: '60', label: 'UTC+01:00' },
  { value: '90', label: 'UTC+01:30' },
  { value: '120', label: 'UTC+02:00' },
  { value: '150', label: 'UTC+02:30' },
  { value: '180', label: 'UTC+03:00' },
  { value: '210', label: 'UTC+03:30' },
  { value: '240', label: 'UTC+04:00' },
  { value: '270', label: 'UTC+04:30' },
  { value: '300', label: 'UTC+05:00' },
  { value: '330', label: 'UTC+05:30' },
  { value: '360', label: 'UTC+06:00' },
  { value: '390', label: 'UTC+06:30' },
  { value: '420', label: 'UTC+07:00' },
  { value: '450', label: 'UTC+07:30' },
  { value: '480', label: 'UTC+08:00' },
  { value: '510', label: 'UTC+08:30' },
  { value: '540', label: 'UTC+09:00' },
  { value: '570', label: 'UTC+09:30' },
  { value: '600', label: 'UTC+10:00' },
  { value: '630', label: 'UTC+10:30' },
  { value: '660', label: 'UTC+11:00' },
  { value: '690', label: 'UTC+11:30' },
  { value: '720', label: 'UTC+12:00' },
  { value: '750', label: 'UTC+12:30' },
  { value: '780', label: 'UTC+13:00' },
  { value: '810', label: 'UTC+13:30' },
  { value: '840', label: 'UTC+14:00' }
];

export const daysOptions = [
  { value: 1, label: '1' },
  { value: 2, label: '2' },
  { value: 3, label: '3' },
  { value: 4, label: '4' },
  { value: 5, label: '5' },
  { value: 6, label: '6' },
  { value: 7, label: '7' },
  { value: 8, label: '8' },
  { value: 9, label: '9' },
  { value: 10, label: '10' },
  { value: 11, label: '11' },
  { value: 12, label: '12' },
  { value: 13, label: '13' },
  { value: 14, label: '14' },
  { value: 15, label: '15' },
  { value: 16, label: '16' },
  { value: 17, label: '17' },
  { value: 18, label: '18' },
  { value: 19, label: '19' },
  { value: 20, label: '20' },
  { value: 21, label: '21' },
  { value: 22, label: '22' },
  { value: 23, label: '23' },
  { value: 24, label: '24' },
  { value: 25, label: '25' },
  { value: 26, label: '26' },
  { value: 27, label: '27' },
  { value: 28, label: '28' },
  { value: 29, label: '29' },
  { value: 30, label: '30' }
];

export const ENUM_ANCHORS = {
  signup: '#signup',
  signupOn: '#signup_on',
  signupDepositOn: '#signup_deposit_on',
  fortune: '#fortune',
  fortuneOn: '#fortune_on',
  deposit: '#deposit'
};

export const hourOptions = [
  { label: '00 00', value: '0' },
  { label: '01 00', value: '60' },
  { label: '02 00', value: '120' },
  { label: '03 00', value: '180' },
  { label: '04 00', value: '240' },
  { label: '05 00', value: '300' },
  { label: '06 00', value: '360' },
  { label: '07 00', value: '420' },
  { label: '08 00', value: '480' },
  { label: '09 00', value: '540' },
  { label: '10 00', value: '600' },
  { label: '11 00', value: '660' },
  { label: '12 00', value: '720' },
  { label: '13 00', value: '780' },
  { label: '14 00', value: '840' },
  { label: '15 00', value: '900' },
  { label: '16 00', value: '960' },
  { label: '17 00', value: '1020' },
  { label: '18 00', value: '1080' },
  { label: '19 00', value: '1140' },
  { label: '20 00', value: '1200' },
  { label: '21 00', value: '1260' },
  { label: '22 00', value: '1320' },
  { label: '23 00', value: '1380' },
  { label: '24 00', value: '1440' }
];

export const dayList = [
  { title: 'Mon', id: 0 },
  { title: 'Tue', id: 1 },
  { title: 'Wed', id: 2 },
  { title: 'Thu', id: 3 },
  { title: 'Fri', id: 4 },
  { title: 'Sat', id: 5 },
  { title: 'Sun', id: 6 }
];

export const sourcePlatformOptions = [
  { label: 'Any', value: 'any' },
  { label: 'Site', value: 'site' },
  { label: 'Bot', value: 'bot' }
];
export const gameModeOptions = [
  { label: 'Normal', value: 'real' },
  { label: 'Demo', value: 'demo' }
];

export const languages = [
  { flagname: 'English (UK)', icon: FlagEn, value: 'en' },
  { flagname: 'Русский', icon: FlagRu, value: 'ru' }
];

export const ENUM_PROMOCODE_STATUS = {
  ALL: 'any',
  enabled: 'active',
  disabled: 'disabled',
  deleted: 'deleted'
};

export const ENUM_PROMO_FILL = {
  all: 'all',
  series: 'series',
  list: 'list'
};

export const ENUM_FS_MODE_STATUS = {
  wait: 'verification required',
  available: 'available',
  unavailable: 'unavailable'
};

export const options0To100 = new Array(101)
  .fill(1)
  .map((_, indx) => ({ label: indx, value: String(indx) }));

export const options0To100Percent = options0To100.map((el) => ({ ...el, label: el.label + '%' }));

export const ENUM_SLIDER_LINK = {
  not: 'not',
  bot: 'bot',
  game: 'game',
  relative: 'relative',
  relativeBanner: 'relativeBanner',
  external: 'external'
};

export const ENUM_SITE_ID = {
  schedulerCreateMailing: 'scheduler_create_mailing'
};

export const ENUM_DEPOSIT_STATUS = {
  any: 'Any',
  created: 'Created',
  paid: 'Paid',
  canceled: 'Canceled',
  expired: 'Expired',
  moderation: 'Moderation',
  paidout: 'Paid out',
  inprocess: 'In process',
  refunded: 'Refunded',
  failed: 'Failed',
  unknown: 'Unknown'
};

export const ENUM_PAYOUT_TYPE = {
  card: 'card',
  acc: 'acc',
  phone: 'phone',
  crypto: 'crypto'
};

export const ENUM_INVOICE_ACTIONS = {
  makePayout: 'makePayout',
  makeReject: 'makeReject',
  checkStatus: 'checkStatus',
  viewRaw: 'viewRaw'
};

export const ENUM_FILTER_JOURNAL = {
  balanceRefill: 'Balance refill',
  userPayout: 'User payout',
  startGame: 'Start game',
  gameSpin: 'Game spin',
  enrollWin: 'Enroll win',
  enrollJackpot: 'Enroll jackpot',
  promocode: 'Promocode',
  bonusActivate: 'Bonus activate',
  welcome: 'Bonus Welcome',
  freespin: 'Bonus Freespin',
  bonus: 'Bonus crediting',
  botMessage: 'Bot message'
};

export const ENUM_CASINO_LIMIT = { input: 'input', output: 'output' };

export const acceptImg = 'image/jpeg,image/jpg,image/gif,image/png,image/webp';

export const optionsAvailability = [
  { label: '——', value: 'skip' },
  { label: 'Yes', value: 'yes' },
  { label: 'No', value: 'no' }
];

export const accountStatusOptions = [
  { label: '——', value: 'skip' },
  { label: 'Active', value: 'active' },
  { label: 'Blocked', value: 'locked' },
  { label: 'For Moderation', value: 'moderated' }
];

export const ENUM_USERS_TYPE = {
  gamer: 'gamer',
  manager: 'manager',
  partner: 'partner',
  agent: 'agent'
};

export const popupInfoByType = {
  [ENUM_USERS_TYPE.gamer]: {
    icon: IconDeviceGamepad2,
    text: 'Player',
    value: ENUM_USERS_TYPE.gamer
  },
  [ENUM_USERS_TYPE.manager]: {
    icon: IconUserCog,
    text: 'Manager',
    value: ENUM_USERS_TYPE.manager
  },
  [ENUM_USERS_TYPE.partner]: {
    icon: IconUsers,
    text: 'Partner',
    value: ENUM_USERS_TYPE.partner
  },
  [ENUM_USERS_TYPE.agent]: {
    icon: IconUserBolt,
    text: 'Agent',
    value: ENUM_USERS_TYPE.agent
  }
};

export const colorByUsersStatus = {
  [ENUM_USERS_TYPE.manager]: '#40c057',
  [ENUM_USERS_TYPE.agent]: '#FA896B',
  [ENUM_USERS_TYPE.partner]: '#E6D800',
  [ENUM_USERS_TYPE.gamer]: '#be4bdb',
  player: '#be4bdb'
};

export const statusOptions = [
  { label: 'all', value: ENUM_PROMOCODE_STATUS.ALL },
  { label: 'Active', value: ENUM_PROMOCODE_STATUS.enabled },
  { label: 'Inactive', value: ENUM_PROMOCODE_STATUS.disabled },
  { label: 'Deleted', value: ENUM_PROMOCODE_STATUS.deleted }
];

export const postOptions = [25, 50, 100, 250, 500].map((el) => ({
  label: el,
  value: el
}));

export const weekDaysEn = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday'
];

export const ENUM_SCHEDULER_STATUS = {
  inactive: 'inactive',
  deleted: 'deleted',
  progress: 'progress',
  finished: 'finished',
  active: 'active'
};

export const StatusNameByStatus = {
  inactive: 'Inactive',
  deleted: 'Deleted',
  progress: 'Progress',
  finished: 'Finished',
  active: 'Active'
};

export const ENUM_SORT_DIRECTION = {
  asc: 'asc',
  desc: 'desc'
};

export const ENUM_DATE_PRESENT_LABEL = {
  today: 'Today',
  yesterday: 'Yesterday',
  currentWeek: 'Current week',
  lastWeek: 'Last week',
  currentMonth: 'Current month',
  lastMonth: 'Last month',
  currentYear: 'Current year',
  lastYear: 'Last year'
};

export const ENUM_STRING_MENU = {
  casinoSetting: 'casino_setting',
  gambitAggregator: 'gambit_aggregator'
};

export const ENUM_FIT_STAT_DETAIL = {
  hour: 'hour',
  day: 'day',
  month: 'month'
};
